<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="/">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>购物券管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索 -->
    <div class="content">
      <el-form
        inline
        :model="query"
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList();"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>

        <el-form-item label="类型">
          <el-select
            v-model="query.type"
            placeholder="请选择类型"
            filterable
            clearable
            @change="saleClick"
          >
            <el-option v-for="item in typelist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="dialogVisible=true;form={isEnable:true};">新增</el-button>
        </el-form-item>
      </el-form>

      <!-- 主体 -->
      <el-card class="box-card table">
        <div class="clearfix" slot="header">
          <span>购物券列表</span>
        </div>

        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          border
          stripe
          style="width:100%;"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="typeName" label="类型"></el-table-column>
          <el-table-column prop="amount" label="金额"></el-table-column>
          <el-table-column prop="minAmount" label="满减金额"></el-table-column>
          <el-table-column prop="stateName" label="状态"></el-table-column>
          <el-table-column prop="count" label="发放量"></el-table-column>
          <el-table-column prop="getCount" label="领取量"></el-table-column>
          <el-table-column prop="getCount" label="使用量"></el-table-column>

          <!-- 操作 -->
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="small"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top:20px;">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50,100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 弹框 -->
    <el-dialog :title="form.id>0?'编辑购物券':'添加购物券'" :visible.sync="dialogVisible">
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
      >
        <el-form-item prop="title" label="标题" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="form.title" placeholder="请输入标题"></el-input>
        </el-form-item>

        <el-form-item label="类型" :rules="[{required:true,message:'不能为空'}]">
          <el-select v-model="form.type" placeholder="请选择类型" filterable clearable>
            <el-option v-for="item in typelist" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="amount" label="金额" :rules="[{required:true,message:'不能为空'}]">
          <el-input v-model="form.amount" placeholder="请输入金额"></el-input>
        </el-form-item>

        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item prop="startTime" label="开始时间" :rules="[{required:true,message:'不能为空'}]">
              <el-date-picker
                v-model="form.startTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="开始时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="endTime" label="结束时间">
              <el-date-picker
                v-model="form.endTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="结束时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="count" label="发放量" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="number" v-model.number="form.count" placeholder="请输入发放量"></el-input>
        </el-form-item>

        <el-form-item prop="minAmount" label="减满金额" :rules="[{required:true,message:'不能为空'}]">
          <el-input type="number" v-model.number="form.minAmount" placeholder="请输入减满金额"></el-input>
        </el-form-item>

        <el-form-item prop="targetID" label="商品关联" v-if="form.type==3">
          <el-select
            placeholder="请选择关联商品"
            v-model="form.targetID"
            style="width:100%;"
            clearable
            filterable
            @change="gooSelect"
          >
            <el-option v-for="item in gooList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="summary" label="简介">
          <el-input v-model="form.summary" placeholder="请输入简介"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
          <el-button @click="dialogVisible=false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      query: {},
      form: {},
      dialogVisible: false,
      loading: false,
      submiting: false,
      pageSize: 10,
      currentPage4: 1,
      tableData: [],
      total: 0,
      typelist: [],
      gooList: []
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag: function(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    // 类型
    getCouponList: function() {
      var _this = this;
      var link = url.getOrder("getcoupontype");
      $.get(link, {}, data => {
        _this.typelist = data;
      });
    },
    //商品
    getGooList() {
      var _this = this;
      var link = url.getMall("getall_goo");
      $.get(link, {}, res => {
        _this.gooList = res;
      });
    },
    // 列表
    getList: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      var link = url.getOrder("getlist_coupon");
      $.get(link, params, data => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 查询
    selList: function() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 按类型查询
    saleClick: function() {
      this.getList();
    },
    // 编辑
    editClick: function(row) {
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    // 删除
    delClick: function(row) {
      var _this = this;
      var id = row.id;
      var link = url.getOrder("delete_coupon");

      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          $.post(link, { id: id }, res => {
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 提交
    submitForm: function(formName) {
      var _this = this;
      var link = url.getOrder("save_coupon");
      var info = _this.form;

      this.$refs.form.validate(valid => {
        if (valid) {
          _this.submiting = true;

          // 提交后台  添加或修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return;
        }
      });
    },
    //选择结果
    gooSelect(e) {
      var _this = this;
      var targetID = e;
      var gooList = this.gooList;
      var thisItem = null;
      for (var i = 0; i < gooList.length; i++) {
        var item = gooList[i];
        if (item.id == targetID) {
          thisItem = item;
          break;
        }
      }
      this.form.summary = item.title;
    }
  },
  mounted() {
    //   类型
    this.getCouponList();
    // 商品
    this.getGooList();
    // 列表
    this.getList();
  }
};
</script>